import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-evento-conoscitivo',
  templateUrl: './evento-conoscitivo.component.html',
  styleUrls: ['./evento-conoscitivo.component.css']
})
export class EventoConoscitivoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
